import { Transparency } from '../../utils/editorReactIcons';
export { Transparency };
export default Transparency;
